const languageEnum = {
  1: 'en-US',
  2: 'pt-PT',
}

export const getLanguage = (val) => {
  return languageEnum[val] || languageEnum[1]
}

export const getLanguageEnumValue = (language) => {
  return Object.keys(languageEnum).find(key => languageEnum[key] === language) || 1;
}

export { languageEnum }
